/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
/**
 * @ngInject
 */
export class BsTooltipFactory {
    constructor($injector) {
        this.$injector = $injector;
    }
    customBindingDirective() {
        return {
            restrict: 'A',
            require: '?^bsTooltipBoundary',
            compile: (element, attrs) => {
                if (!('bsTooltipToggle' in attrs) && !('bsPopoverToggle' in attrs)) {
                    return (scope, element, attrs, ctrl) => {
                        const directive = this.$injector.get('bsTooltipToggleDirective')[0], bsTooltipToggleCtrl = this.$injector.instantiate(directive.controller, {
                            '$scope': scope,
                            '$element': element,
                            '$attrs': attrs
                        });
                        directive.compile(element, scope, attrs, [ctrl, bsTooltipToggleCtrl])(scope, element, attrs, [ctrl, bsTooltipToggleCtrl]);
                        bsTooltipToggleCtrl.$onInit();
                        element.on('$destroy', function () {
                            bsTooltipToggleCtrl.$onDestroy();
                        });
                    };
                }
            }
        };
    }
}
